import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { ReturnsReturnProcessIdentification } from '@itsrever/rever-api'
import { returnsApiProxy } from '@/redux/api/returns-api-slice'

// A voided label is replaced through the same flow that made it, so the new one
// shows up in the tracking info and the label query as any first label does.
export const useRequestNewLabel = ({
  email,
  process_id
}: Partial<ReturnsReturnProcessIdentification>) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      if (email === undefined || process_id === undefined) return
      await returnsApiProxy.requestNewLabel({
        returnsRequestNewLabelRequest: {
          return_process_identification: { email, process_id }
        }
      })
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['tracking-info', email, process_id]
      })
      await queryClient.invalidateQueries({
        queryKey: ['label-url', email, process_id]
      })
    }
  })
}
